import { json, type LoaderFunctionArgs, type SerializeFrom } from "@remix-run/node";
import { useParams } from "@remix-run/react";
import { cacheHeader } from "pretty-cache-header";

import { useFetch } from "~/hooks/useFetch";
import { createServerStateManager } from "~/modules/StateManager.server";
import { getPlaceDetailsById, getPlaceDetailsByLatLng } from "~/services/google.server";

export type PlaceDetailLoaderData = SerializeFrom<typeof loader>;

export async function loader(args: LoaderFunctionArgs) {
  const searchParams = new URL(args.request.url).searchParams;
  const latlng = searchParams.get("geolocation");
  const place_id = searchParams.get("placeId");
  const sessiontoken = searchParams.get("sessionToken");

  const stateManager = await createServerStateManager(args);
  const config = await stateManager.getRequestConfig();

  if (place_id && sessiontoken) {
    const placeDetails = await getPlaceDetailsById({ place_id, sessiontoken, config });

    return json(placeDetails, CACHE_HEADERS);
  } else if (latlng) {
    const placeDetails = await getPlaceDetailsByLatLng({ latlng, config });

    return json(placeDetails, CACHE_HEADERS);
  }

  return json(null, CACHE_HEADERS);
}

export function usePlaceDetailApiFetcher() {
  const { enterprise } = useParams<"enterprise">();
  const fetcher = useFetch<PlaceDetailLoaderData>(`/api/enterprises/${enterprise}/place-details`);

  return fetcher;
}

const CACHE_HEADERS = {
  headers: {
    "Cache-Control": cacheHeader({ public: true, maxAge: "5minutes" }),
  },
};
